import { object, string } from "yup";

export type Subtype = {
	foreignKey: string | null;
	id: number;
	name: string;
};

export type SubtypeEdit = Omit<Subtype, "id">;

export const buildDefaultSubtype = (): SubtypeEdit => ({
	foreignKey: "",
	name: ""
});

export const validationSchema = object().shape({
	name: string().required("入力してください")
});
